<template>
  <div id="app" class="flex flex-col h-screen mx-auto p-4 bg-gradient-to-br from-blue-600 via-indigo-500 to-purple-700 relative">
    <!-- Animated Background Elements -->
    <div class="absolute top-0 left-0 w-full h-full overflow-hidden z-0">
      <div class="absolute w-96 h-96 bg-white opacity-10 rounded-full -top-20 -left-20 animate-pulse-slow"></div>
      <div class="absolute w-80 h-80 bg-blue-300 opacity-10 rounded-full top-40 right-10 animate-float"></div>
      <div class="absolute w-64 h-64 bg-purple-300 opacity-10 rounded-full bottom-20 left-40 animate-float-delayed"></div>
    </div>
    
    <!-- Header -->
    <div class="mb-4 relative z-10">
      <router-link to="/" class="no-underline text-white">
        <div class="logo-text-chat flex items-center">
          <span class="text-white">inter<span class="text-yellow-300">bot</span></span>
          <div class="ml-2 bg-yellow-300 p-1 rounded-md">
            <span class="text-xs font-bold text-blue-700">IA</span>
          </div>
        </div>
      </router-link>
    </div>
    
    <!-- Interview Setup Modal -->
    <InterviewSetupModal
      v-if="showSetup"
      v-model:interviewCodeGenerated="interviewCodeGenerated"
      v-model:chatSessionId="chatSessionId"
      @start="startInterview"
      @close="closeSetup"
      apiEndpoint="/api"
    />
    
    <!-- Interview Chat -->
    <InterviewChat
      v-else
      :chatSessionId="chatSessionId"
      @goToAnalysis="goToAnalysis"
    />
    
    <!-- Modals -->
    <NewSessionConfirmation
      v-if="showNewSessionConfirmation"
      @confirm="confirmNewSession"
      @cancel="cancelNewSession"
    />
    
    <CodeDialog
      v-if="showCodePopUp"
      :interviewLink="interviewLink"
      :intCode="intCode"
      @close="closeCode"
    />
  </div>
</template>

<script>
import InterviewChat from '../components/InterviewChat.vue';
import NewSessionConfirmation from '../components/NewSessionConfirmation.vue';
import CodeDialog from '../components/CodeDialog.vue';
import InterviewSetupModal from '../components/InterviewSetup/InterviewSetupModal.vue'

export default {
  name: 'InterbotView',
  components: {
    InterviewSetupModal,
    InterviewChat,
    NewSessionConfirmation,
    CodeDialog,
  },
  data() {
    return {
        showSetup: true,
        chatSessionId: null,
        interviewCodeGenerated: false,
        showNewSessionConfirmation: false,
        showCodePopUp: false,
    };
  },
  computed: {
      interviewLink() {
          return `https://interbot.mx?code=${this.chatSessionId}`;
      },
      intCode() {
          return `${this.chatSessionId}`;
      },
  },
  async mounted() {
    const interviewCode = this.$route.query.code;
    if (interviewCode) {
      this.chatSessionId = interviewCode;
      this.interviewCodeGenerated = true;
        this.showSetup = false;
    } else {
      this.chatSessionId = localStorage.getItem('chatSessionId') || null;
      if (this.chatSessionId) {
        this.interviewCodeGenerated = true;
          this.showSetup = false;
      }
    }
  },
  methods: {
      showCode() {
          this.showCodePopUp = true;
      },
      closeCode() {
          this.showCodePopUp = false;
      },
      startInterview(data) {
          this.interviewCodeGenerated = data.interviewCodeGenerated;
          this.chatSessionId = data.chatSessionId
          this.showSetup = false;
      },
      closeSetup(){
         this.showSetup = false;
      },
    goToAnalysis() {
        this.$router.push({ path: '/analysis', query: { code: this.chatSessionId } });
    },
    confirmNewSession() {
      this.chatSessionId = null;
      localStorage.removeItem('chatSessionId');
        this.showSetup = true;
        this.interviewCodeGenerated = false;
      this.showNewSessionConfirmation = false;
    },
    cancelNewSession() {
      this.showNewSessionConfirmation = false;
    },
  },
};
</script>

<style scoped>
@keyframes pulse-slow {
  0%, 100% {
    opacity: 0.7;
  }
  50% {
    opacity: 0.3;
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
}

@keyframes float-delayed {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-15px);
  }
}

.animate-pulse-slow {
  animation: pulse-slow 4s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.animate-float {
  animation: float 8s ease-in-out infinite;
}

.animate-float-delayed {
  animation: float-delayed 7s ease-in-out infinite;
  animation-delay: 2s;
}

/* Apply blur effect for glass morphism */
.backdrop-blur-sm {
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

/* Enhanced button hover effects */
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

/* Improved card hover animations */
.hover\:scale-105:hover {
  transform: scale(1.05);
}

.hover\:-translate-y-1:hover {
  transform: translateY(-4px);
}
</style>